import React from 'react';
import FaClose from 'react-icons/lib/fa/close';

export const CloseModal = ({ onHide }) =>
  <a className="close-modal-link pull-right" onClick={onHide}>
    <FaClose />
  </a>;



/** WEBPACK FOOTER **
 ** ./src/components/layout/close-modal.jsx
 **/